import React from "react";
import { Link } from "react-router-dom";

export const CallforWorkshop = () => {
  return (
    <div className="visa-big-box container">
      <h5>
        IHCI 2023 invites workshop organizers to submit proposals for
        interactive and engaging workshops to be held in conjunction with the
        conference. Workshops provide a platform for in-depth discussions,
        hands-on activities, and knowledge exchange in specific areas related to
        Human-Computer Interaction (HCI). Here are the details and guidelines
        for submitting workshop proposals
      </h5>

      <h4>1. Workshop Topics</h4>
      <h5 className="information">
        We welcome workshops on a wide range of topics related to HCI, including
        but not limited to:
      </h5>
      <ul>
        <li>Emerging trends and technologies in HCI</li>
        <li>User experience design and evaluation</li>
        <li>Interaction techniques and interfaces</li>
        <li>Human-centered design and innovation</li>
        <li>Ethical and inclusive design practices</li>
        <li>Cognitive and affective aspects of interaction</li>
        <li>Social computing and collaborative interfaces</li>
        <li>Augmented and virtual reality experiences</li>
        <li>Wearable computing and ubiquitous interactions</li>
        <li>Usability testing and evaluation methods</li>
        <li>Human-robot interaction and intelligent interfaces</li>
      </ul>

      <h4>2. Workshop Format</h4>
      <h5 className="information">
        Proposals should clearly outline the workshop format and duration.
        Workshops can be{" "}
        <b style={{ textDecoration: "none", color: "#FF9933" }}>
          half-day or full-day
        </b>{" "}
        events and can include a combination of presentations, hands-on
        activities, demos, group discussions, and interactive sessions.
      </h5>

      <h4>3. Audience</h4>
      <h5 className="information">
        Specify the target audience for your workshop, such as researchers,
        practitioners, industry professionals, students, or a combination
        thereof. Consider the level of expertise and prior knowledge required
        for participants to benefit from the workshop.
      </h5>

      <h4>4. Organizers</h4>
      <h5 className="information">
        Provide a brief introduction to the workshop organizers, including their
        expertise and experience in the field of HCI. Include their affiliations
        and contact information.
      </h5>

      <h4>5. Call for Participation</h4>
      <h5 className="information">
        Proposals should include a call for participation that will be used to
        attract potential attendees to the workshop. The call should clearly
        describe the workshop's objectives, the topics to be covered, and any
        prerequisites or requirements for participation.
      </h5>

      <h4>6. Workshop Description</h4>
      <h5 className="information">
        Submit a detailed description of the workshop, including the goals,
        intended outcomes, and how it aligns with the themes of IHCI 2023.
        Explain how the workshop will facilitate active engagement, knowledge
        sharing, and collaboration among participants.
      </h5>

      <h4>7. Logistics</h4>
      <h5 className="information">
        Specify any logistical requirements or special considerations, such as
        room setup, audiovisual equipment, materials, and any additional support
        needed from the conference organizers.
      </h5>

      <h4>8. Submission Guidelines</h4>
      <h5 className="information">
        To submit your workshop proposal via the online{" "}
        <Link to="https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FIHCI2023">
          CMT
        </Link>{" "}
        site or by email:{" "}
        <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>,
        please provide a comprehensive document addressing the points mentioned
        above. Additionally, include a proposed schedule or agenda for the
        workshop and a tentative list of confirmed or potential speakers, if
        applicable.
      </h5>

      <h4>9. Deadline</h4>
      <h5 className="information">
        The deadline for workshop proposals is{" "}
        <b style={{ textDecoration: "none", color: "#FF9933" }}>
          July 15, 2023
        </b>
        . Please ensure that your submission is completed before this date.
      </h5>
      <br />
      <br />
      <h5>
        We encourage creative and interactive workshop proposals that will
        enhance the overall conference experience for attendees. We look forward
        to receiving your proposals and hosting engaging workshops at IHCI 2023,
        where we aim to foster collaboration, innovation, and knowledge exchange
        in the field of Human-Computer Interaction.
      </h5>
      <hr className="hr-style" />
    </div>
  );
};
